/**
 * Número de ruta (ACH) — sic-frontend
 *
 * Point rechaza el pago ACH si la ruta no tiene exactamente 9 dígitos (PREM-374).
 * El backend (claims-tracker-api) aplica la misma regla al guardar el acuerdo.
 */

export const ROUTE_NUMBER_LENGTH = 9;

export const ROUTE_NUMBER_MESSAGE =
  'El número de ruta debe tener 9 dígitos numéricos';

/** Deja solo los dígitos (descarta guiones, espacios y letras) y corta en 9. */
export const sanitizeRouteNumber = (value?: string | null): string =>
  (value ?? '').replace(/[^0-9]/g, '').slice(0, ROUTE_NUMBER_LENGTH);

export const isValidRouteNumber = (value?: string | null): boolean =>
  /^[0-9]{9}$/.test(value ?? '');
